import { render } from "./PGBusinessPage.vue?vue&type=template&id=5a7945ae"
import script from "./PGBusinessPage.vue?vue&type=script&lang=js"
export * from "./PGBusinessPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__